import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CollectionModel } from 'src/app/shared/models/collections/collection-model';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CategoryModel, CategoryModelV2 } from 'src/app/shared/models/mazaya-plus/category-model';
import { DataModel } from 'src/app/shared/models/mazaya-plus/data-model';
import { UserModel } from 'src/app/shared/models/users/user-model';
import { MazayaEcardDetails } from 'src/app/shared/models/users/e-cart-details';
import { PaymentDetailsModel } from 'src/app/shared/models/mazaya-plus/payment-details-model';

@Injectable({
  providedIn: 'root'
})
export class MazayaPlusService {
  private collections = `${environment.serverUrl}/MazayaCategory/getallmembership_old`;
  private resource = `${environment.serverUrl}/users/`;
  private ecardcreate = `${environment.serverUrl}/MazayaEcard/ecardcreate`;
  private ecardPowercreate= `${environment.serverUrl}/MazayaPowerExplore/powerexplorecreate`;
  private paymentstatus = `${environment.serverUrl}/MazayaEcard/paymentstatus`;
  private ecardupdate = `${environment.serverUrl}/MazayaEcard/ecardupdate`;
  private getEcard = `${environment.nodeServerUrl1}/buyer/ecards/mazaya-card`;
  private userInfo = `${environment.nodeServerUrl1}/users/info`;
  private applePayment=`${environment.nodeServerUrl}/payfort/apple-pay`;
  private tabbyPayment=`${environment.nodeServerUrl}/tabby/mazaya-payment/createPayment`;
  private getAllEcard = `${environment.serverUrl}/MazayaEcard/ecardmainbyuserid`;


  constructor(private http: HttpClient) { }

  getAllMemberships(): Observable<DataModel<CategoryModel>> {
    const url = `${this.collections}`;
    return this.http.get<any>(url);
  }
  getAllMembershipsV2(isAddOn:boolean,isAbleRenew:boolean): Observable<DataModel<CategoryModelV2>> {
    const url = `${environment.nodeServerUrl1}/buyer/company-categories?isGoldaddedon=${isAddOn}&isRenew=${isAbleRenew}`;
    return this.http.get<any>(url);
  }

  getUserProfile(): Observable<UserModel> {
    return this.http.get<UserModel>(`${environment.nodeServerUrl1}/users/details`);
  }
  validateApplePayMerchant(validationURL: string): Observable<any> {
    return this.http.post<any>(`${this.applePayment}/request-session`, { url: validationURL });
  }


  processApplePayPurchase(paymentData: any): Observable<any> {
    return this.http.post<any>(`${this.applePayment}/purchase`, paymentData);
  }
  createEcard(eCartDetails: any): Observable<any> {

    return this.http.post<any>(`${environment.nodeServerUrl1}/buyer/ecards/purchase`, eCartDetails);
  }
  createPayment(tabbyDetails:any):Observable<any>{
  
    return this.http.post<any>(this.tabbyPayment, tabbyDetails);

  }
  createPower(eCartDetails: any): Observable<any> {

    return this.http.post<any>(`${environment.nodeServerUrl1}/power-explore`, eCartDetails);
  }
  paymentStatus(eCartDetails: PaymentDetailsModel,id:string): Observable<any> {

    return this.http.post<any>(`${this.paymentstatus}?transaction_id=${id}&&status=${true}`, eCartDetails);
  }

  downloadFile(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' });
  }

  ecardUpdate(eCartDetails): Observable<any> {

    return this.http.put<any>(`${environment.nodeServerUrl1}/buyer/ecards/${eCartDetails.id}/invite`, eCartDetails);
   //  return this.http.put<any>(`${this.getEcard}/${eCartDetails.id}/invite`, eCartDetails);
  }

  getEcards(transactionId: any): Observable<any> {
    return this.http.get<any>(`${this.getEcard}?transaction_id=${transactionId}`);
  }
  getPowerExploreCards(transactionId: any): Observable<any> {
    return this.http.get<any>(`${environment.serverUrl}/mazayaPowerExplore/getPowerExploreEcard?transaction_id=${transactionId}`);
  }
  getUserInfo(): Observable<any> {
    const url = `${this.userInfo}`;
    return this.http.get<any>(url);
  }
  getEcardWithId(): Observable<any> {
    return this.http.get<any>(`${this.getAllEcard}`);
  }
  getUpgradeMembership(isGoldUpdate:boolean): Observable<any> {
    return this.http.get<any>(`${environment.nodeServerUrl1}/buyer/ecards/upgraded-card`);
  }
  upgradeMembership(rqBody:any): Observable<any> {
    return this.http.post<any>(`${environment.serverUrl}/MazayaUpgrade/ecardupgrade`,rqBody);
  }
  upgradeToGoldAddOn(rqBody:any): Observable<any> {
    return this.http.post<any>(`${environment.nodeServerUrl1}/buyer/ecards/purchase/goldplus`,rqBody);
  }


  payment(data: any): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });
    let options = { headers: headers };
    return this.http
      .post<any>(
        'https://sbpaymentservices.payfort.com/FortAPI/paymentApi',
        data,
        options,
      )
  }


    validateCoupon(rqbody:{CouponCode:string}): Observable<any> {
    return this.http.post<any>(`${environment.nodeServerUrl1}/coupon-configuration/buyer/validate-purchase`,rqbody);
  }

   updateEcardPaymentStatus(eCartDetails: any,id:number): Observable<any> {
    return this.http.post<any>(`${environment.nodeServerUrl1}/buyer/ecards/paymentstatus?&transaction_id=${id}&status=true`, eCartDetails);
  }

     updatePowerExplorePaymentStatus(eCartDetails: any,id:number): Observable<any> {
    return this.http.post<any>(`${environment.nodeServerUrl1}/payment/power-explore/payment-statusweb?paymentGwayId=${id}&status=true`, eCartDetails);
  }
}


